<script>
export default {
  form: {
    currency: {
      label: 'Devise des prix',
      type: 'select',
      column: 'is-12',
      options: {
        EUR: 'Euro (€)',
        CAD: 'Dollar canadien ($ CA)',
        CHF: 'Franc suisse (CHF)',
      },
      inputAttrs: {
        expanded: true,
      },
    },
  },
  data() {
    return {
      isLoading: false,
      store: {
        currency: '',
      },
    };
  },
  computed: {
    authStore() {
      return this.$store.getters['auth/store'];
    },
    hasCurrencyChanged() {
      return this.store.currency !== this.authStore.currency;
    },
  },
  created() {
    Object.keys(this.store)
      .forEach((k) => (this.store[k] = this.authStore[k]));
  },
  methods: {
    handle() {
      if (this.hasCurrencyChanged) {
        this.$buefy.dialog.confirm({
          title: 'Changer de devise',
          message: 'La nouvelle devise sera appliquée à l\'ensemble de vos formations et packs.',
          confirmText: 'Confirmer le changement',
          cancelText: 'Annuler',
          type: 'is-warning',
          focusOn: 'cancel',
          onConfirm: () => this.save(),
        });
      } else {
        this.save();
      }
    },
    save() {
      this.isLoading = true;
      this.$store.dispatch('auth/updateStore', { ...this.store })
        .then(() => this.$showMessage.success())
        .catch((error) => {
          const currencyErrors = error?.response?.data?.errors?.currency;
          if (currencyErrors) {
            this.$buefy.dialog.alert({
              title: 'Changement impossible',
              message: currencyErrors[0],
              type: 'is-danger',
            });
            this.store.currency = this.authStore.currency;
            return;
          }
          this.$errorHandlers.axios(error);
        })
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>

<template>
  <div class="columns">
    <div class="column is-4 content pr-10 is-small">
      <h2 class="is-size-5">
        Devise
      </h2>
      <p>
        Choisissez la devise à utiliser pour l'ensemble de vos ventes
        (formations, packs, ...). Cette devise ne sera plus modifiable
        dès que vous aurez effectué votre première vente.
      </p>
    </div>

    <div class="column">
      <form novalidate class="box" @submit.prevent="dataIsValid(isLoading) && handle()">
        <div class="columns is-multiline">
          <div v-for="(field, k) in $options.form" :key="k" class="column" :class="field.column">
            <BaseField v-model="store[k]" :field="field" />
          </div>
        </div>

        <b-field class="has-text-right">
          <b-button type="is-primary" native-type="submit" :loading="isLoading">
            Mettre à jour
          </b-button>
        </b-field>
      </form>
    </div>
  </div>
</template>
